const getUserLanguageCSR = (): string | undefined => {
  if (typeof window !== "undefined" && window.__INITIAL_STATE__) {
    const initialState: any = window.__INITIAL_STATE__;
    return initialState.appData.userLanguage;
  }
  return "en";
};

export default getUserLanguageCSR;
